import { typedQueryClient, useTypedMutation } from "hooks";
import { AppointmentDetailsKeys } from "modules/AppointmentDetails/queryKeys";
import { ApiInstance } from "utils/Api";

export type ToggleAttachmentVisibilityPayload = {
  intervention_attachment_id?: number;
  visible_to_customer: boolean;
};

export const useToggleAttachmentVisibilityMutation = () =>
  useTypedMutation<ToggleAttachmentVisibilityPayload, void>({
    mutationFn: async payload => {
      await ApiInstance.post("/interventions/attachment/update_visible_to_customer", payload);
    },
    onSuccess: payload => {
      const appointment = typedQueryClient.getQueryData(AppointmentDetailsKeys.view);
      if (!appointment?.interventions || !payload.intervention_attachment_id) return;

      const { interventions } = appointment;
      const matchingInterventionIdx = interventions.findIndex(intervention =>
        intervention.attachments?.some(attachment => attachment.id === payload.intervention_attachment_id)
      );

      if (matchingInterventionIdx === -1 || !interventions[matchingInterventionIdx].attachments?.length) return;

      const attachmentIdx = interventions[matchingInterventionIdx].attachments.findIndex(attachment => attachment.id === payload.intervention_attachment_id);

      if (attachmentIdx === -1) return;

      const updatedAttachments = interventions[matchingInterventionIdx].attachments.with(attachmentIdx, {
        ...interventions[matchingInterventionIdx].attachments[attachmentIdx],
        visible_to_customer: payload.visible_to_customer
      });

      typedQueryClient.setQueryData(AppointmentDetailsKeys.view, {
        ...appointment,
        interventions: interventions.with(matchingInterventionIdx, { ...interventions[matchingInterventionIdx], attachments: updatedAttachments })
      });
    }
  });
